
import Vue from 'vue'
import App from './App.vue'

require("@/store/subscriber.js")

// Vuesax Component Framework
import Vuesax from 'vuesax'
import 'material-icons/iconfont/material-icons.css' //Material Icons
import 'vuesax/dist/vuesax.css'; // Vuesax
Vue.use(Vuesax)


import { StripePlugin } from '@vue-stripe/vue-stripe'

const options = {
  pk: 'pk_live_51JVEJVAgBrYvqz2mvKj4m0gwXs9gYWnXDUI17VhsKghKpcOtr2sjlgkczvWV0ik7Bh6tKRxReqhXJlSHEe2B2uJ100us8fPRKr',
  stripeAccount: 'acct_1JVEJVAgBrYvqz2m',
  apiVersion: '2020-08-27',
  locale: 'fr'
}

Vue.use(StripePlugin, options)


// axios
import axios from "./axios.js"
Vue.prototype.$http = axios

// echo
// import echo from "./echo.js"
// Vue.prototype.$echo = echo

// Theme Configurations
import '../themeConfig.js'


// Globally Registered Components
import './globalComponents.js'


// Styles: SCSS
import './assets/scss/main.scss'


// Tailwind
import '@/assets/css/main.css'


// Vue Router
import router from './router'


// Vuex Store
import store from './store/store'


// Vuejs - Vue wrapper for hammerjs
import { VueHammer } from 'vue2-hammer'
Vue.use(VueHammer)

// VeeValidate
import VeeValidate from 'vee-validate';
Vue.use(VeeValidate);


// PrismJS
import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'


// Feather font icon
require('./assets/css/iconfont.css')

// SweetAlert
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
Vue.use(VueSweetalert2);


// AutoComplete
import { AutoCompletePlugin } from '@syncfusion/ej2-vue-dropdowns';
Vue.use(AutoCompletePlugin);

// cookies
import VueCookies from 'vue-cookies'
Vue.use(VueCookies)

// Lightbox
import VueSilentbox from 'vue-silentbox'
Vue.use(VueSilentbox)

// Mobile Detection
import VueMobileDetection from 'vue-mobile-detection'
Vue.use(VueMobileDetection)

// moment
import VueMoment from 'vue-moment'
const moment = require('moment')
require('moment/locale/fr')
Vue.use(VueMoment, {
  moment
})


import VueSignature from "vue-signature-pad";
Vue.use(VueSignature);


Vue.config.productionTip = false

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')



store.dispatch('auth/attempt', {access_token:Vue.$cookies.get('token')}).then((response) => {
  if(!!response && response.data.success == false){
      store.dispatch('auth/attempt', {access_token: Vue.$cookies.get('token')}).then((response) => {
        new Vue({
          router,
          store,
          render: h => h(App)
        }).$mount('#app')
      })
  }else{
    new Vue({
      router,
      store,
      render: h => h(App)
    }).$mount('#app')
  }
 
})